function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { _Api } from "../../../services/core";

/** Permet de vérifier si l'element possède bien le champs */
var Checker = {
  hasTimeToPark: function hasTimeToPark(element, mode) {
    return true;
    // switch (mode) {
    //   case 'mode_velo_personnel_electrique':
    //   case 'mode_velo_personnel_mecanique':
    //   case 'mode_velo_cargo_personnel_electrique':
    //   case 'mode_velo_cargo_personnel_mecanique':
    //   case 'mode_voiture_personnelle_electrique':
    //   case 'mode_voiture_personnelle_hybride':
    //   case 'mode_voiture_personnelle_thermique':
    //   case 'mode_voiture_de_fonction_electrique':
    //   case 'mode_voiture_de_fonction_hybride':
    //   case 'mode_voiture_de_fonction_thermique':
    //   case 'mode_covoiturage_conducteur_electrique':
    //   case 'mode_covoiturage_conducteur_hybride':
    //   case 'mode_covoiturage_conducteur_thermique':
    //     return element.time_to_park && element.time_to_park !== '';
    //   default:
    //     return true;
    // }
  },
  hasDistance: function hasDistance(element) {
    return true;
    return element.distance && element.distance !== '';
  },
  hasDistanceParkingToDestination: function hasDistanceParkingToDestination(element, mode) {
    return true;
    // switch (mode) {
    //   case 'mode_velo_personnel_electrique':
    //   case 'mode_velo_personnel_mecanique':
    //   case 'mode_velo_cargo_personnel_electrique':
    //   case 'mode_velo_cargo_personnel_mecanique':
    //   case 'mode_voiture_personnelle_electrique':
    //   case 'mode_voiture_personnelle_hybride':
    //   case 'mode_voiture_personnelle_thermique':
    //   case 'mode_voiture_de_fonction_electrique':
    //   case 'mode_voiture_de_fonction_hybride':
    //   case 'mode_voiture_de_fonction_thermique':
    //   case 'mode_covoiturage_conducteur_electrique':
    //   case 'mode_covoiturage_conducteur_hybride':
    //   case 'mode_covoiturage_conducteur_thermique':
    //     return element.distance_parking_to_destination && element.distance_parking_to_destination !== '';
    //   default:
    //     return true;
    // }
  },
  verifyQuestion: function verifyQuestion(element, mode, params) {
    if (typeof mode === 'string') {
      return true;
    }
    var categories = params.split(',').map(function (el) {
      return el.trim();
    });
    var isValid = true;
    mode.categories.forEach(function (category) {
      if (categories.includes(category.name)) {
        isValid = element.carpooling_app && element.carpooling_app !== '';
      }
    });
    return isValid;
  },
  getResponseFormatted: function getResponseFormatted(journey, questionAlias) {
    var journeyFormatted = {};
    journey.forEach(function (item, index) {
      Object.keys(item).forEach(function (field) {
        var _value, _value2, _value3;
        if (field === 'errors') {
          return;
        }
        var value = item[field];
        switch (field) {
          case 'departure':
          case 'arrival':
          case 'line':
            value = ((_value = value) === null || _value === void 0 ? void 0 : _value._id) || ((_value2 = value) === null || _value2 === void 0 ? void 0 : _value2.id) || value;
            break;
          case 'mode':
            value = (_value3 = value) === null || _value3 === void 0 ? void 0 : _value3.alias;
            break;
          default:
            break;
        }
        journeyFormatted["".concat(questionAlias, "_").concat(field, "_j").concat(index)] = value;
      });
    });
    return journeyFormatted;
  },
  isJourneyValid: function () {
    var _isJourneyValid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(response, question) {
      var journey, i, _question$publicParam, _question$publicParam2, _question$publicParam3, _question$publicParam4, _step$mode, step, cr1, cr3, cr4, cr5;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Checker.formatResponses(response, question);
          case 2:
            journey = _context.sent;
            if (!(!journey || journey.length === 0)) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", false);
          case 5:
            i = 0;
          case 6:
            if (!(i <= journey.length - 2)) {
              _context.next = 18;
              break;
            }
            step = journey[i];
            cr1 = Checker.verifyQuestion(step, step.mode, question === null || question === void 0 || (_question$publicParam = question.publicParameters) === null || _question$publicParam === void 0 ? void 0 : _question$publicParam.q_carpooling_app);
            cr3 = Checker.verifyQuestion(step, step.mode, (_question$publicParam2 = question.publicParameters) === null || _question$publicParam2 === void 0 ? void 0 : _question$publicParam2.q_nb_passager);
            cr4 = Checker.verifyQuestion(step, step.mode, (_question$publicParam3 = question.publicParameters) === null || _question$publicParam3 === void 0 ? void 0 : _question$publicParam3.q_distance_parking_destination);
            cr5 = Checker.verifyQuestion(step, step.mode, (_question$publicParam4 = question.publicParameters) === null || _question$publicParam4 === void 0 ? void 0 : _question$publicParam4.q_time_to_park);
            if (!(!cr1 || !cr3 || !cr4 || !cr5)) {
              _context.next = 14;
              break;
            }
            return _context.abrupt("return", false);
          case 14:
            response["".concat(question.alias, "_mode_j").concat(i)] = (_step$mode = step.mode) === null || _step$mode === void 0 ? void 0 : _step$mode.alias;
          case 15:
            i++;
            _context.next = 6;
            break;
          case 18:
            return _context.abrupt("return", true);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function isJourneyValid(_x, _x2) {
      return _isJourneyValid.apply(this, arguments);
    }
    return isJourneyValid;
  }(),
  formatResponses: function () {
    var _formatResponses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(histResp, question) {
      var formatted, getAlias, aliasHR, i, oldAlias, alias, splitAlias, index, value, respDeparture, responseLine, _ref, expectedResponses, _i, _expectedResponses$_i;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            formatted = [{
              time: '00:00'
            }, {
              time: '00:00'
            }];
            if (!(null === histResp || Object.keys(histResp).length === 0)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return", formatted);
          case 3:
            getAlias = function getAlias(oldAlias) {
              var currentAlias = oldAlias.replace(question.alias, '');
              if (currentAlias.search('departure') !== -1) {
                return 'departure';
              }
              if (currentAlias.search('arrival') !== -1) {
                return 'arrival';
              }
              if (currentAlias.search('line') !== -1) {
                return 'line';
              }
              if (currentAlias.search('time') !== -1) {
                return 'time';
              }
              if (currentAlias.search('mode') !== -1) {
                return 'mode';
              }
              if (currentAlias.search('carpooling_app') !== -1) {
                return 'carpooling_app';
              }
              if (currentAlias.search('distance_parking_to_destination') !== -1) {
                return 'distance_parking_to_destination';
              }
              if (currentAlias.search('distance') !== -1) {
                return 'distance';
              }
              if (currentAlias.search('nb_passengers') !== -1) {
                return 'nb_passengers';
              }
              if (currentAlias.search('time_to_park') !== -1) {
                return 'time_to_park';
              }
              return null;
            }; // ON récupère les réponses pour faire un for classique
            aliasHR = Object.keys(histResp);
            i = 0;
          case 6:
            if (!(i < aliasHR.length)) {
              _context2.next = 51;
              break;
            }
            oldAlias = aliasHR[i];
            alias = getAlias(oldAlias);
            splitAlias = oldAlias.split('_j');
            index = splitAlias[splitAlias.length - 1];
            value = histResp[oldAlias];
            if (!(null === alias)) {
              _context2.next = 14;
              break;
            }
            return _context2.abrupt("continue", 48);
          case 14:
            _context2.prev = 14;
            _context2.t0 = alias;
            _context2.next = _context2.t0 === 'departure' ? 18 : _context2.t0 === 'arrival' ? 18 : _context2.t0 === 'line' ? 24 : _context2.t0 === 'mode' ? 30 : 41;
            break;
          case 18:
            if (!(value && value !== 'NA')) {
              _context2.next = 23;
              break;
            }
            _context2.next = 21;
            return _Api.get("/points/".concat(value, "/public"));
          case 21:
            respDeparture = _context2.sent;
            if (respDeparture.data) {
              value = respDeparture.data;
            }
          case 23:
            return _context2.abrupt("break", 41);
          case 24:
            if (!(value && value !== 'NA')) {
              _context2.next = 29;
              break;
            }
            _context2.next = 27;
            return _Api.get("/points/".concat(value, "/public"));
          case 27:
            responseLine = _context2.sent;
            if (responseLine.data) {
              value = responseLine.data;
            }
          case 29:
            return _context2.abrupt("break", 41);
          case 30:
            _ref = question || {}, expectedResponses = _ref.expectedResponses;
            if (!expectedResponses) {
              _context2.next = 40;
              break;
            }
            _i = 0;
          case 33:
            if (!(_i < expectedResponses.length)) {
              _context2.next = 40;
              break;
            }
            if (!(((_expectedResponses$_i = expectedResponses[_i]) === null || _expectedResponses$_i === void 0 ? void 0 : _expectedResponses$_i.alias) === value)) {
              _context2.next = 37;
              break;
            }
            value = expectedResponses[_i];
            return _context2.abrupt("break", 40);
          case 37:
            _i++;
            _context2.next = 33;
            break;
          case 40:
            return _context2.abrupt("break", 41);
          case 41:
            _context2.next = 46;
            break;
          case 43:
            _context2.prev = 43;
            _context2.t1 = _context2["catch"](14);
            console.error(_context2.t1);
          case 46:
            if (!formatted[index]) {
              formatted[index] = {};
            }
            formatted[index][alias] = value;
          case 48:
            i++;
            _context2.next = 6;
            break;
          case 51:
            return _context2.abrupt("return", formatted);
          case 52:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[14, 43]]);
    }));
    function formatResponses(_x3, _x4) {
      return _formatResponses.apply(this, arguments);
    }
    return formatResponses;
  }()
};
export default Checker;